module.exports = __webpack_public_path__ + "img/edit.837c2895.svg";